module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n  " + _vm._s(_vm.displayValue) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7369316e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-countTo.vue
// module id = 5
// module chunks = 0